import React from 'react'

const InfoContent = ({content}) => {
  return (
    <>
    <div className="user__page__content_inner user__page__content_info">
    <p>{content}</p>
    </div>
    </>
  )
}

export default InfoContent